import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const unitPremiseDocumentsRoute: RouteConfig<'with-page'> = {
    name: 'Unit Documents',
    path: '/unit-premises/:unitId/documents',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}